<template>
  <div class="content">
    <h1 class="has-text-centered">Raspberry Pi GPIO Pins</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          Ein leistungsfähiges Merkmal des Raspberry Pi sind die GPIO-Pins (GPIO = General Purpose Input/Output) entlang der oberen Kante des Boards. Eine 40-polige GPIO-Steckleiste befindet sich auf allen aktuellen Raspberry Pi-Platinen (auf Pi Zero und Pi Zero W ist sie nicht bestückt). Vor dem Pi 1 Model B+ (2014) verfügten die Boards über eine kürzere 26-polige Stiftleiste.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/raspberry_GPIO-Pinout-Diagram.webp">
      <p class="is-size-7-mobile">
        Bild von <a target="_blank" href="https://www.raspberrypi.org/documentation/">https://www.raspberrypi.org/documentation/</a>
      </p>
    </div>
    <div class="box">
      <table class="table is-hoverable is-striped is-bordered has-text-centered is-size-7-mobile">
        <thead>
          <tr>
            <th class="th-pins">Beschreibung</th>
            <th class="th-pins" colspan="2">Pins</th>
            <th class="th-pins">Beschreibung</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>3V3 power</td>
            <td class="has-text-weight-bold td-pins">1</td>
            <td class="has-text-weight-bold td-pins">2</td>
            <td>5V power</td>
          </tr>
          <tr>
            <td>GPIO 2 (<router-link :to="{name: 'glossary-s', hash: '#SDA'}">SDA</router-link>)</td>
            <td class="has-text-weight-bold td-pins">3</td>
            <td class="has-text-weight-bold td-pins">4</td>
            <td>5V power</td>
          </tr>
          <tr>
            <td>GPIO 3 (<router-link :to="{name: 'glossary-s', hash: '#SCL'}">SCL</router-link>)</td>
            <td class="has-text-weight-bold td-pins">5</td>
            <td class="has-text-weight-bold td-pins">6</td>
            <td>Ground</td>
          </tr>
          <tr>
            <td>GPIO 4 (GPCLK0)</td>
            <td class="has-text-weight-bold td-pins">7</td>
            <td class="has-text-weight-bold td-pins">8</td>
            <td>GPIO 14 (<router-link :to="{name: 'glossary-t', hash: '#TXD'}">TXD</router-link>)</td>
          </tr>
          <tr>
            <td>Ground</td>
            <td class="has-text-weight-bold td-pins">9</td>
            <td class="has-text-weight-bold td-pins">10</td>
            <td>GPIO 15 (<router-link :to="{name: 'glossary-r', hash: '#RXD'}">RXD</router-link>)</td>
          </tr>
          <tr>
            <td>GPIO 17</td>
            <td class="has-text-weight-bold td-pins">11</td>
            <td class="has-text-weight-bold td-pins">12</td>
            <td>GPIO 18 (PCM_CLK)</td>
          </tr>
          <tr>
            <td>GPIO 27</td>
            <td class="has-text-weight-bold td-pins">13</td>
            <td class="has-text-weight-bold td-pins">14</td>
            <td>Ground</td>
          </tr>
          <tr>
            <td>GPIO 22</td>
            <td class="has-text-weight-bold td-pins">15</td>
            <td class="has-text-weight-bold td-pins">16</td>
            <td>GPIO 23</td>
          </tr>
          <tr>
            <td>3V3 power</td>
            <td class="has-text-weight-bold td-pins">17</td>
            <td class="has-text-weight-bold td-pins">18</td>
            <td>GPIO 24</td>
          </tr>
          <tr>
            <td>GPIO 10 (<router-link :to="{name: 'glossary-m', hash: '#MOSI'}">MOSI</router-link>)</td>
            <td class="has-text-weight-bold td-pins">19</td>
            <td class="has-text-weight-bold td-pins">20</td>
            <td>Ground</td>
          </tr>
          <tr>
            <td>GPIO 9 (<router-link :to="{name: 'glossary-m', hash: '#MISO'}">MISO</router-link>)</td>
            <td class="has-text-weight-bold td-pins">21</td>
            <td class="has-text-weight-bold td-pins">22</td>
            <td>GPIO 25</td>
          </tr>
          <tr>
            <td>GPIO 11 (<router-link :to="{name: 'glossary-s', hash: '#SCLK'}">SCLK</router-link>)</td>
            <td class="has-text-weight-bold td-pins">23</td>
            <td class="has-text-weight-bold td-pins">24</td>
            <td>GPIO 8 (CE0)</td>
          </tr>
          <tr>
            <td>Ground</td>
            <td class="has-text-weight-bold td-pins">25</td>
            <td class="has-text-weight-bold td-pins">26</td>
            <td>GPIO 7 (CE1)</td>
          </tr>
          <tr>
            <td>GPIO 0 (ID_SD)</td>
            <td class="has-text-weight-bold td-pins">27</td>
            <td class="has-text-weight-bold td-pins">28</td>
            <td>GPIO 1 (ID_SC)</td>
          </tr>
          <tr>
            <td>GPIO 5</td>
            <td class="has-text-weight-bold td-pins">29</td>
            <td class="has-text-weight-bold td-pins">30</td>
            <td>Ground</td>
          </tr>
          <tr>
            <td>GPIO 6</td>
            <td class="has-text-weight-bold td-pins">31</td>
            <td class="has-text-weight-bold td-pins">32</td>
            <td>GPIO 12 (PWM0)</td>
          </tr>
          <tr>
            <td>GPIO 13 (PWM1)</td>
            <td class="has-text-weight-bold td-pins">33</td>
            <td class="has-text-weight-bold td-pins">34</td>
            <td>Ground</td>
          </tr>
          <tr>
            <td>GPIO 19 (PCM_FS)</td>
            <td class="has-text-weight-bold td-pins">35</td>
            <td class="has-text-weight-bold td-pins">36</td>
            <td>GPIO 16</td>
          </tr>
          <tr>
            <td>GPIO 26</td>
            <td class="has-text-weight-bold td-pins">37</td>
            <td class="has-text-weight-bold td-pins">38</td>
            <td>GPIO 20 (PCM_DIN)</td>
          </tr>
          <tr>
            <td>Ground</td>
            <td class="has-text-weight-bold td-pins">39</td>
            <td class="has-text-weight-bold td-pins">40</td>
            <td>GPIO 21 (PCM_DOUT)</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-raspberry-pi',
  metaInfo: {
    title: 'Raspberry Pi GPIO | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine 40-polige GPIO-Steckleiste befindet sich auf allen aktuellen Raspberry Pi-Platinen ➤ Hier findest du eine Übersicht!'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
